export default __webpack_public_path__ + "static/media/wink.92b806b6.png";